import { atom } from 'nanostores'

export const $receiptSystemAccountId = atom<string | null>(null)
